import React, { useState, useEffect } from 'react';
import {
  func, string, bool,
} from 'prop-types';

import makeStyles from '@material-ui/core/styles/makeStyles';
import MuiModal from '@material-ui/core/Modal';
import {
  Typography, Box, Paper,
} from '@material-ui/core';
import { useTheme } from '@material-ui/styles';
import cookies from 'react-cookies';

import { Button, Checkbox, AvonHeader } from '@avon/component-library';

import Modal from '../Modal';

import getDeviceType, { isMobile, isTablet } from '../../utils/getDeviceType';

const useStyles = makeStyles(theme => ({
  toolbar: {
    display: 'flex',
    zIndex: 102,
    width: '100%',
    textAlign: 'justify',
    textAlignLast: 'justify',
    paddingLeft: styleProps => (styleProps.language === 'ar' ? theme.spacing(3) : theme.spacing(1)),
    paddingRight: styleProps => (styleProps.language === 'ar' ? theme.spacing(1) : theme.spacing(3)),
    boxShadow: styleProps => (styleProps.hideToolbarShadow === true ? 'unset' : '0 2px 4px 0 rgba(0, 0, 0, 0.1)'),
    backgroundColor: theme.palette.colors.white,
    '& span': {
      fontFamily: 'Montserrat',
      fontWeight: 700,
      fontSize: 16,
    },
  },
  gridButton1: {
    minHeight: theme.spacing(3),
    width: 'auto',
    paddingTop: 0,
    paddingBottom: 0,
    wordBreak: 'break-word',
    color: theme.palette.colors.textDark,
  },
  gridButton2: {
    minHeight: theme.spacing(3),
    width: 'auto',
    paddingTop: 0,
    paddingBottom: 0,
    wordBreak: 'break-word',
    color: theme.palette.colors.corePink,
    '&:hover': {
      backgroundColor: 'rgba(24, 24, 24, 0.08)',
    },
  },
  colButtons: {
    display: 'flex',
    flexDirection: 'column',
    position: 'fixed',
    bottom: 0,
    width: '100%',
    padding: 16,
    marginBottom: 50,
  },
  rowButtons: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    position: 'fixed',
    bottom: 0,
    width: p => p.innerWidth - (p.deviceType === 'tablet' ? 120 : 388),
    padding: 16,
    marginBottom: 60,
    direction: 'rtl',
    marginLeft: p => (p.deviceType === 'tablet' ? 60 : 194),
    marginRight: p => (p.deviceType === 'tablet' ? 60 : 194),
  },
  heading: {
    marginTop: p => (p.deviceType === 'tablet' ? 52 : 72),
    marginLeft: p => (p.deviceType === 'tablet' ? 60 : 194),
    marginRight: p => (p.deviceType === 'tablet' ? 60 : 194),
  },
  headingLabel: {
    fontSize: p => (p.deviceType === 'tablet' ? '24px' : '42px'),
    fontFamily: 'Montserrat',
    fontWeight: '300',
    textAlign: p => (p.deviceType === 'tablet' ? 'left' : 'center'),
  },
  body: {
    // eslint-disable-next-line
    marginTop: p => (p.deviceType === 'mobile' ? 18 : (p.deviceType === 'tablet' ? 52 : 30)),
    // eslint-disable-next-line
    marginLeft: p => (p.deviceType === 'mobile' ? 16 : (p.deviceType === 'tablet' ? 60 : 194)),
    // eslint-disable-next-line
    marginRight: p => (p.deviceType === 'mobile' ? 16 : (p.deviceType === 'tablet' ? 60 : 194)),
    height: p => (p.deviceType === 'mobile' ? p.innerHeight - 350 : p.innerHeight - 450),
    overflow: 'auto',
  },
  checkGroup: {
    direction: p => (p.language === 'ar' ? 'rtl' : 'ltr'),
    // eslint-disable-next-line
    marginLeft: p => (p.language === 'ar' ? 'unset' : (p.deviceType === 'mobile' ? 16 : (p.deviceType === 'tablet' ? 60 : 194))),
    // eslint-disable-next-line
    marginRight: p => (p.language === 'ar' ? (p.deviceType === 'mobile' ? 16 : (p.deviceType === 'tablet' ? 60 : 194)) : 'unset'),
    position: 'fixed',
    bottom: p => (p.deviceType === 'mobile' ? 200 : 150),
  },
  typography: {
    lineHeight: theme.spacing(5),
  },
  clickableText: {
    color: theme.palette.primary.main,
    fontFamily: 'Montserrat',
    fontWeight: 700,
  },
  mobileHeader: {
    height: 44,
    display: 'flex',
    alignItems: 'center',
  },
  headingLabelMobile: {
    fontFamily: 'Montserrat',
    fontSize: 16,
    lineHeight: '24px',
    fontWeight: '500',
    position: 'relative',
    left: -12,
  },
  bodyToast: {
    backgroundColor: '#181818',
    display: 'flex',
    alignItems: 'center',
    position: 'fixed',
    width: '100%',
    height: 48,
  },
  justineLogo: {
    textAlign: 'center',
    paddingTop: 20,
  },
  divide: {
    height: 3,
    marginTop: 20,
    background: `linear-gradient(to right, ${theme.palette.colors.corePink} 0%, #E2197C 64.421%, #E5231B 100%)`,
  },
}));

const TaC = ({
  open,
  closeModal,
  submitData,
  saveLabel,
  cancelLabel,
  cancelButtonPriority,
  isSubmitting,
  hideToolbarShadow,
  getAgrmntContent,
  agrType,
}) => {
  const theme = useTheme();
  const deviceType = getDeviceType();
  const language = cookies.load('langCd');
  const mrktCd = cookies.load('mrktCd');
  const [innerWidth] = useState(window.innerWidth);
  const [innerHeight] = useState(window.innerHeight);
  const styleProps = {
    language, hideToolbarShadow, deviceType, innerHeight, innerWidth,
  };
  const classes = useStyles(styleProps);

  const [checked, setChecked] = useState(false);
  const [bodyToastShow, setBodyToastShow] = useState(true);
  const [content, setContent] = useState({});

  const [declineModalShow, setDeclineModalShow] = useState(false);

  const toggleCheck = () => setChecked(!checked);
  const toggleBodyToast = () => setBodyToastShow(!bodyToastShow);
  const closeDeclineModal = () => setDeclineModalShow(false);
  const openDeclineModal = () => setDeclineModalShow(true);

  useEffect(() => {
    const getContext = async () => {
      await getAgrmntContent(agrType).then(res => setContent(res.legalInfo[0]));
    };

    getContext();
  }, []);

  const mobileCloseSvg = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M7.6129 6.2097C7.22061 5.90468 6.65338 5.93241 6.29289 6.29289C5.90237 6.68342 5.90237 7.31658 6.29289 7.70711L10.5858 12L6.29289 16.2929L6.2097 16.3871C5.90468 16.7794 5.93241 17.3466 6.29289 17.7071C6.68342 18.0976 7.31658 18.0976 7.70711 17.7071L12 13.4142L16.2929 17.7071L16.3871 17.7903C16.7794 18.0953 17.3466 18.0676 17.7071 17.7071C18.0976 17.3166 18.0976 16.6834 17.7071 16.2929L13.4142 12L17.7071 7.70711L17.7903 7.6129C18.0953 7.22061 18.0676 6.65338 17.7071 6.29289C17.3166 5.90237 16.6834 5.90237 16.2929 6.29289L12 10.5858L7.70711 6.29289L7.6129 6.2097Z" fill="#181818" />
    </svg>
  );

  const infoIconSvg = (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M22.5 12C22.5 6.47715 18.0228 2 12.5 2C6.97715 2 2.5 6.47715 2.5 12C2.5 17.5228 6.97715 22 12.5 22C18.0228 22 22.5 17.5228 22.5 12ZM12.5 17C13.0128 17 13.4355 16.614 13.4933 16.1166L13.5 16V11C13.5 10.4477 13.0523 10 12.5 10C11.9872 10 11.5645 10.386 11.5067 10.8834L11.5 11V16C11.5 16.5523 11.9477 17 12.5 17ZM12.5 7C13.0523 7 13.5 7.44771 13.5 8C13.5 8.55229 13.0523 9 12.5 9C11.9477 9 11.5 8.55229 11.5 8C11.5 7.44771 11.9477 7 12.5 7Z" fill="white" />
    </svg>
  );

  const closeIconSvg = (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M8.1129 6.2097C7.72061 5.90468 7.15338 5.93241 6.79289 6.29289C6.40237 6.68342 6.40237 7.31658 6.79289 7.70711L11.0858 12L6.79289 16.2929L6.7097 16.3871C6.40468 16.7794 6.43241 17.3466 6.79289 17.7071C7.18342 18.0976 7.81658 18.0976 8.20711 17.7071L12.5 13.4142L16.7929 17.7071L16.8871 17.7903C17.2794 18.0953 17.8466 18.0676 18.2071 17.7071C18.5976 17.3166 18.5976 16.6834 18.2071 16.2929L13.9142 12L18.2071 7.70711L18.2903 7.6129C18.5953 7.22061 18.5676 6.65338 18.2071 6.29289C17.8166 5.90237 17.1834 5.90237 16.7929 6.29289L12.5 10.5858L8.20711 6.29289L8.1129 6.2097Z" fill="white" />
    </svg>
  );

  const justineLogo = (
    <svg width="141" height="39" viewBox="0 0 141 58" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M139.723 32.0702C130.364 40.609 126.439 40.2476 123.416 38.686C122.129 38.0815 121.831 35.9674 123.615 34.6595C132.222 29.0855 134.084 18.0241 123.283 25.0565C121.001 26.598 117.865 30.0873 116.612 36.3714C107.908 39.9005 107.607 37.2619 108.593 32.172C111.224 24.3497 109.31 23.4361 102.855 29.4278C101.444 27.9519 100.357 28.0712 98.6341 29.7709L91.2069 35.5148C84.1317 40.1167 82.8195 39.049 86.4054 32.0462C89.832 26.7848 89.3294 24.7377 83.7787 30.0285C83.2787 30.9249 82.8209 31.7726 82.3928 32.5848C67.8998 46.1704 69.6049 38.3271 80.307 18.7961C106.334 17.6777 134.945 16.6457 134.945 16.6457L136.272 13.4037C136.272 13.4037 107.477 13.8772 84.6222 14.5093C81.1618 14.7658 82.2049 14.5131 84.0188 10.9075C86.1615 6.58314 84.7675 5.79074 82.4279 7.30718C81.0715 8.02606 80.6222 9.74727 79.7267 11.6795C79.1085 13.4073 78.4338 14.2645 77.7012 14.2514L62.7163 14.671L60.6522 19.3107C67.591 18.349 72.0566 18.2621 76.3561 18.5938L67.9111 36.5435C64.1244 46.9961 68.3585 48.9594 79.8419 37.9208C76.2598 46.6102 80.1566 46.5274 91.5441 37.6602C94.5936 35.3027 95.3503 35.8184 93.8229 39.2015C92.9949 41.5168 94.0189 44.0574 96.0926 41.8403L98.9659 37.944C102.174 34.0844 102.582 33.9281 102.498 38.5572C102.805 43.3791 107.303 44.5925 113.322 41.3439C115.569 40.0894 116.375 39.2396 117.643 40.9853C123.313 46.5868 133.311 43.6449 140.485 33.1844C141.118 31.5389 140.864 31.1662 139.723 32.0702ZM122.351 30.0285L123.872 27.2848C124.884 25.8269 126.235 27.1127 125.391 29.1705L124.545 30.285C123.028 32.9426 121.733 32.3999 122.351 30.0285ZM58.178 24.9582C56.5147 26.9923 55.9861 28.2719 55.9151 29.443C55.7266 30.4661 56.1403 30.1516 54.8144 31.0518L51.3283 33.579C41.3425 41.3134 40.5522 38.0537 48.2933 26.0164C49.4623 23.6425 44.4906 25.5165 41.5567 28.5689C41.1318 31.2212 39.8381 33.4499 37.673 35.2588C33.6939 39.2015 31.4955 38.8739 33.6939 34.4003L36.66 28.0557C38.3544 24.6301 37.5047 24.2718 33.525 26.8556C31.2127 28.243 31.1551 28.5458 29.9807 31.6568L26.2657 40.5736C25.0087 44.126 26.7391 44.697 30.2456 42.6322L34.4657 40.06C37.3283 37.7101 38.4533 37.9391 37.8424 40.7454C37.7658 44.1277 41.6207 44.6371 45.7762 42.1178L51.8802 36.1237C54.1435 33.8505 56.0681 32.953 57.6157 34.5639C59.3905 35.9654 60.255 37.5184 60.6319 38.8586C61.1833 40.228 59.9955 42.2014 58.4378 40.5736C58.2451 38.9259 57.3272 38.9441 55.7363 40.2318C54.7351 40.9167 54.0263 41.5005 54.0472 43.1457C54.3467 46.0008 56.5989 45.8859 60.8008 42.8043C67.7478 37.6504 68.649 33.4774 63.5025 30.285C61.3095 28.9627 60.9753 28.109 63.3331 26.1683C66.4858 23.4557 63.2294 19.98 58.178 24.9582ZM39.0806 0L33.1594 0.697634C31.8703 0.885793 31.0741 0.944066 30.8509 2.51115C25.4478 24.4782 23.1757 44.1464 0 58C29.4829 49.9965 39.0806 0 39.0806 0Z" fill="#F37331" />
    </svg>
  );

  return (
    <MuiModal
      data-testid={`web-TaC-modal-${agrType}`}
      key={`web-TaC-modal-${agrType}`}
      id={`web-TaC-modal-${agrType}`}
      open={open}
    >
      <Box
        width="100%"
        position="fixed"
        margin="auto"
        bottom="0"
      >
        <Paper>
          <Box height={innerHeight} p={0} data-testid="error-modal" id="prospect-error-modal">
            {(!isMobile() && mrktCd === 'JT')
              ? (
                <Box
                  component="div"
                  mx="auto"
                  data-testid="convFlowHeader"
                  id="justineHeader"
                  className={classes.justineLogo}
                >
                  {justineLogo}
                  <div className={classes.divide} />
                </Box>
              )
              : null
            }
            {(!isMobile() && mrktCd !== 'JT') ? <AvonHeader /> : null}
            <Box height={innerHeight} style={{ direction: language === 'ar' ? 'rtl' : 'ltr' }}>
              <Box>
                {isMobile() ? (
                  <Box style={{ direction: language === 'ar' ? 'ltr' : 'rtl' }} className={classes.mobileHeader}>
                    <Box m="10px" onClick={openDeclineModal}>{mobileCloseSvg}</Box>
                    <Box textAlign="center" style={{ flexGrow: 1 }}>
                      <Typography className={classes.headingLabelMobile}>
                        {content.heading}
                      </Typography>
                    </Box>
                  </Box>
                ) : (
                  <Box mb={5} textAlign="center" className={classes.heading}>
                    <Typography className={classes.headingLabel}>{content.heading}</Typography>
                  </Box>
                )}
                {isMobile() && bodyToastShow ? (
                  <Box className={classes.bodyToast}>
                    <Box m="12px 10px 12px 20px">{infoIconSvg}</Box>
                    <Box>
                      <Typography style={{
                        color: '#FFFFFF', fontSize: 14, fontWeight: '500', fontFamily: 'Montserrat',
                      }}
                      >
                        {content.tipLabel}
                      </Typography>
                    </Box>
                    <Box
                      style={{
                        position: 'absolute',
                        right: language === 'ar' ? 'unset' : 20,
                        left: language === 'ar' ? 20 : 'unset',
                      }}
                      onClick={toggleBodyToast}
                    >
                      {closeIconSvg}
                    </Box>
                  </Box>
                ) : null}
                <Box mb={5} textAlign="center" className={classes.body}>
                  <div dangerouslySetInnerHTML={{
                    __html: content.content && content.content.tcText,
                  }}
                  />
                </Box>
              </Box>
              <Box p={0} textAlign="left" className={classes.checkGroup}>
                <Checkbox
                  name={`check-${agrType}`}
                  onChange={toggleCheck}
                  checked={checked}
                  label={(
                    <Typography>
                      {content.checkboxLabel}
                    </Typography>
                  )}
                />
              </Box>
              <Box className={isMobile() ? classes.colButtons : classes.rowButtons} style={{ direction: language === 'ar' ? 'ltr' : 'rtl' }}>
                {saveLabel && (
                  <Box
                    // eslint-disable-next-line
                    ml={isMobile() ? 'unset' : (language === 'ar' ? 'unset' : '12px')}
                    // eslint-disable-next-line
                    mr={isMobile() ? 'unset' : (language === 'ar' ? '12px' : 'unset')}
                    // eslint-disable-next-line
                    style={{ width: isMobile() ? 'unset' : (isTablet() ? (innerWidth - 120) / 2 : (innerWidth - 388) / 2) }}>
                    <Button
                      priority="primary"
                      name={`web-TaC-modal-${agrType}-save`}
                      id={`web-TaC-modal-${agrType}-save`}
                      onClick={submitData}
                      loading={isSubmitting}
                      disabled={!checked}
                    >
                      {saveLabel}
                    </Button>
                  </Box>
                )}
                {
                  cancelLabel && (
                    // eslint-disable-next-line
                    <Box mt={isMobile() ? '10px' : 'unset'} style={{ width: isMobile() ? 'unset' : (isTablet() ? (innerWidth - 120) / 2 : (innerWidth - 388) / 2) }}>
                      <Button
                        priority={cancelButtonPriority || 'secondary'}
                        name={`web-TaC-modal-${agrType}-close`}
                        id={`web-TaC-modal-${agrType}-close`}
                        onClick={openDeclineModal}
                      >
                        {cancelLabel}
                      </Button>
                    </Box>
                  )
                }
              </Box>
            </Box>
          </Box>
        </Paper>

        <Modal
          open={declineModalShow}
          icon
          color={{
            fontColor: theme.palette.colors.textDark,
            borderColor: theme.palette.colors.textDark,
          }}
          heading={content.containerDialog && content.containerDialog[0].heading}
          body={content.containerDialog && content.containerDialog[0].body}
          saveLabel={content.containerDialog && content.containerDialog[0].positiveButton}
          cancelLabel={content.containerDialog && content.containerDialog[0].negativeButton}
          submitData={closeModal}
          closeModal={closeDeclineModal}
        />
      </Box>
    </MuiModal>
  );
};

TaC.propTypes = {
  closeModal: func,
  open: bool.isRequired,
  submitData: func.isRequired,
  saveLabel: string.isRequired,
  cancelLabel: string,
  cancelButtonPriority: string,
  isSubmitting: bool,
  hideToolbarShadow: bool,
  getAgrmntContent: func,
  agrType: string,
};


export default TaC;
